import React, { createContext, useState } from "react";

interface EnrollmentActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
}

export const EnrollmentActionContext = createContext<EnrollmentActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},  
});

interface EnrollmentActionProviderProps {
  children: React.ReactNode;
}

export const EnrollmentActionProvider: React.FC<EnrollmentActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,    
  };
  return (
    <EnrollmentActionContext.Provider value={value}>
      {children}
    </EnrollmentActionContext.Provider>
  );
};
